import QRCodeWrapper from "./QRCodeWrapper";
import AppConfig from "../../AppConfig";
import {Modal, View} from "../react-native-components-in-react/react-native-components-in-react";
import {useEffect, useState} from "react";
import {GetAuthObject} from "../../authentication/AuthFunctions";

const TQRCodeModal = {
    "enUS": {
        REQUEST_WAITER_MSG: 'To use the "Request a Waiter" functionality you need to create a QR Code for each table, you can do this here <strong><a href="/admin/business?openConfig=true">here</a></strong>',
        HELP: 'If you need help send us an email to <a href="mailto:admin@tastee.app">admin@tastee.app</a>',
    },
    "esMX": {
        REQUEST_WAITER_MSG: 'Para usar la funcionalidad de "Solicitar un Mesero" necesitas crear un Código QR para cada mesa, puedes hacer eso <strong><a href="/admin/business?openConfig=true">aquí</a></strong>',
        HELP: 'Si necesitas ayuda envía un correo a <a href="mailto:admin@tastee.app">admin@tastee.app</a>',
    }
}

const QRCodeModal = ({visible, onRequestClose, menuID}) => {
    const auth = GetAuthObject()
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        if(!visible)
            return;

        const fetchData = async() => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchMenuLogo/" + menuID, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            const json = await response.json();

            if(json.image)
                setLogo(json.image);
        }

        fetchData()

    }, [visible]);

    return <Modal
        visible={visible}
        onRequestClose={onRequestClose}
    >
        {
            false && auth.sub && auth.sub.code === AppConfig.SUB_STANDARD ?
                <View className={'alert alert-info'}>
                    <div dangerouslySetInnerHTML={{ __html: TQRCodeModal[AppConfig.lang].REQUEST_WAITER_MSG}}></div>
                </View>
                :
                null
        }
        <QRCodeWrapper
            url={AppConfig.DOMAIN + '/PublicActions/MenuProxy/' + menuID}
            logo={logo}
            showDownloadButton={true}
        />
    </Modal>
}

export default QRCodeModal